module.exports = __webpack_public_path__ + "Roboto-BoldItalic.e444caa994b0279779d1.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-BoldItalic.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-BoldItalic.woff
// module chunks = 2